function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonGoogle = ({
  children,
  ...props
}) => {
  return React.createElement(ButtonGoogleWrap, _extends({}, props, {
    iconLeft: React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 32 33"
    }, React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, React.createElement("g", {
      id: "Logo/Third-Party/Google/G/Default",
      "fill-rule": "nonzero"
    }, React.createElement("g", {
      id: "Google__G__Logo"
    }, React.createElement("path", {
      d: "M31.9700935,16.7117757 C31.9700935,15.6052336 31.8803738,14.4927103 31.688972,13.4041121 L16.3349533,13.4041121 L16.3349533,19.6725234 L25.1274766,19.6725234 C24.7626168,21.6942056 23.5902804,23.4826168 21.8736449,24.6190654 L21.8736449,28.6863551 L27.1192523,28.6863551 C30.1996262,25.851215 31.9700935,21.6642991 31.9700935,16.7117757 Z",
      id: "Path",
      fill: "#4285F4"
    }), React.createElement("path", {
      d: "M16.3349533,32.6160748 C20.7252336,32.6160748 24.4276636,31.1745794 27.1252336,28.6863551 L21.8796262,24.6190654 C20.4201869,25.6119626 18.5360748,26.1742056 16.3409346,26.1742056 C12.0942056,26.1742056 8.49345794,23.3091589 7.20149533,19.4571963 L1.78841121,19.4571963 L1.78841121,23.6500935 C4.5517757,29.1469159 10.1801869,32.6160748 16.3349533,32.6160748 Z",
      id: "Path",
      fill: "#34A853"
    }), React.createElement("path", {
      d: "M7.19551402,19.4571963 C6.51364486,17.435514 6.51364486,15.2463551 7.19551402,13.2246729 L7.19551402,9.0317757 L1.78841121,9.0317757 C-0.520373832,13.6314019 -0.520373832,19.0504673 1.78841121,23.6500935 L7.19551402,19.4571963 Z",
      id: "Path",
      fill: "#FBBC04"
    }), React.createElement("path", {
      d: "M16.3349533,6.50168224 C18.6557009,6.46579439 20.8986916,7.33906542 22.5794393,8.94205607 L22.5794393,8.94205607 L27.2269159,4.29457944 C24.2841121,1.53121495 20.3783178,0.0119626168 16.3349533,0.0598130841 C10.1801869,0.0598130841 4.5517757,3.52897196 1.78841121,9.0317757 L7.19551402,13.2246729 C8.48149533,9.36672897 12.0882243,6.50168224 16.3349533,6.50168224 Z",
      id: "Path",
      fill: "#EA4335"
    })))))
  }), children);
};
export const ButtonGoogleWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.google};
  color: ${props => props.theme.colors.inputText};

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.google};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;